import React, { useState } from "react";
import api from "../../api/axios";

export default function IntegrationExtras({ data, setData, mobileFieldsOnly }: any) {
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const [newType, setNewType] = useState("string");

  const [testPhone, setTestPhone] = useState("");
  const [testResult, setTestResult] = useState<string | null>(null);

  const addField = () => {
    if (!newKey.trim()) return;

    // ✔ всегда берём актуальное состояние
    setData((prev: any) => ({
      ...prev,
      config: { ...prev.config, [newKey]: newValue },
      fieldTypes: { ...prev.fieldTypes, [newKey]: newType },
    }));

    setNewKey("");
    setNewValue("");
    setNewType("string");
  };

  const testSms = async () => {
    try {
      await api.post("/auth/send-code", { phone: testPhone });
      setTestResult("SMS успешно отправлено");
    } catch (err: any) {
      setTestResult("Ошибка: " + (err.response?.data?.message || "Неизвестная ошибка"));
    }
  };

  // mobileFieldsOnly: только тесты (SMS/WA) без формы добавления поля
  if (mobileFieldsOnly) {
    if (data.name !== "sms" && data.name !== "whatsapp") return null;
    return (
      <div className="extras-panel">
        {data.name === "sms" && (
          <>
            <h3>Тестирование SMS</h3>
            <input placeholder="+7707..." value={testPhone} onChange={(e) => setTestPhone(e.target.value)} />
            <button className="save-btn" onClick={testSms}>Отправить тестовый код</button>
            {testResult && <div className="sms-test-result">{testResult}</div>}
          </>
        )}
        {data.name === "whatsapp" && (
          <>
            <h3>Тест WhatsApp</h3>
            <input placeholder="77XXXXXXXXX" value={testPhone} onChange={(e) => setTestPhone(e.target.value)} />
            <button className="save-btn" onClick={async () => {
              try {
                const res = await api.post("/notifications/test-send", { phone: testPhone, text: "Тест уведомления KeyOff CRM ✅" });
                setTestResult(res.data.ok ? "✅ Отправлено" : "❌ Ошибка");
              } catch (e: any) { setTestResult("❌ " + (e?.response?.data?.message ?? e?.message)); }
            }}>Отправить тест</button>
            {testResult && <div className="sms-test-result">{testResult}</div>}
          </>
        )}
      </div>
    );
  }

  return (
    <div className="extras-panel">
      <h3>Добавить поле</h3>

      <input
        placeholder="Ключ"
        value={newKey}
        onChange={(e) => setNewKey(e.target.value)}
      />

      <select value={newType} onChange={(e) => setNewType(e.target.value)}>
        <option value="string">Строка</option>
        <option value="textarea">Многострочный</option>
        <option value="number">Число</option>
        <option value="boolean">Чекбокс</option>
        <option value="secret">Секрет</option>
      </select>

      <input
        placeholder="Значение"
        value={newValue}
        onChange={(e) => setNewValue(e.target.value)}
      />

      <button className="save-btn" onClick={addField}>
        Добавить поле
      </button>

      {data.name === "sms" && (
        <>
          <h3>Тестирование SMS</h3>
          <input
            placeholder="+7707..."
            value={testPhone}
            onChange={(e) => setTestPhone(e.target.value)}
          />
          <button className="save-btn" onClick={testSms}>
            Отправить тестовый код
          </button>
          {testResult && <div className="sms-test-result">{testResult}</div>}
        </>
      )}

      {data.name === "whatsapp" && (
        <>
          <h3>Тест отправки WhatsApp</h3>
          <input
            placeholder="77XXXXXXXXX"
            value={testPhone}
            onChange={(e) => setTestPhone(e.target.value)}
          />
          <button
            className="save-btn"
            onClick={async () => {
              try {
                const res = await api.post("/notifications/test-send", {
                  phone: testPhone,
                  text: "Тест уведомления KeyOff CRM ✅",
                });
                setTestResult(res.data.ok ? "✅ Сообщение отправлено" : "❌ Ошибка отправки");
              } catch (e: any) {
                setTestResult("❌ " + (e?.response?.data?.message ?? e?.message));
              }
            }}
          >
            Отправить тестовое сообщение
          </button>
          {testResult && <div className="sms-test-result">{testResult}</div>}
        </>
      )}
    </div>
  );
}
